import type { NotificationData } from "@mantine/notifications";
import { isValidElement } from "react";
import type { ApiError } from "../../api";
import { getErrorText } from "../../utils/get-error-text";

function extractMessage(
  message:
    NotificationData["message"] | ApiError | Error | string[] | string | unknown
): NotificationData["message"] {
  // Check if content is an AxiosError and convert it to a string
  if ((message as ApiError).response) {
    const errorText = getErrorText(message);
    return Array.isArray(errorText) ? errorText.join("\n\n") : errorText;
  } else if ((message as Error).message) {
    return (message as Error).message;
  } else if (message && Array.isArray(message)) {
    return message.join("\n\n");
  } else if (isValidElement(message)) {
    return message;
  } else {
    return message as string;
  }
}

export { extractMessage };
